import React from 'react';
import _ from 'underscore';
import RaisedButton from 'material-ui/RaisedButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckDouble, faChartLine } from '@fortawesome/free-solid-svg-icons'
import ReactTooltip from 'react-tooltip';

import FsdsaiPersonalized from '../../components/Programs/FsdsaiPersonalized';
import FswdPersonalized from '../../components/Programs/FswdPersonalized';
import FewdPersonalized from '../../components/Programs/FewdPersonalized';
import BewdPersonalized from '../../components/Programs/BewdPersonalized';
import FsdsaiImmersive from '../../components/Programs/FsdsaiImmersive';
import FswdImmersive from '../../components/Programs/FswdImmersive';
import FewdImmersive from '../../components/Programs/FewdImmersive';
import BewdImmersive from '../../components/Programs/BewdImmersive';
import TopRank from './TopRank';

// import Info from './Info';
import Discount from './Discount';

import './StepOne.scss';

class StepOne extends React.Component {
  render() {
    if (!this.props.selectedTrack) { return null; }
    
    const selection = this.props.selectedTrack;
    const personalizedPrice = _.find(selection.relationships.price_options.data, option => option.attributes.name === 'personalized');
    const immersivePrice = _.find(selection.relationships.price_options.data, option => option.attributes.name === 'immersive');
    
    const { long_symbol } = selection.attributes;

    const propsForProgram = {
      immersivePrice: immersivePrice,
      personalizedPrice: personalizedPrice,
      numOfAssignments: selection.attributes.num_of_assignments,
      numOfHours: selection.attributes.num_of_hours,
      numOfMentorshipMinutes: selection.attributes.num_of_mentorship_minutes
    };

    return (
      <div className="container" id="step-one">
        <div className='row price-content'>
          <div className="mx-auto">
            <Discount rate={this.props.rate} />
          </div>

          <div className='col-12 rounded boxshadowSubtle overflowHidden'>
            <div className="row">
              <div className='col-lg-2 col-12 bg-light tuitionInfo'>
                <div className="py-3" id="info">
                  <div className="px-2">
                    <div className='nmLogo' style={{ backgroundColor: selection.attributes.color, color: 'white' }}>
                      {selection.attributes.short_symbol}
                    </div>

                    <h5 className="m-0 pt-3 pl-0">{selection.attributes.long_name}</h5>
                  </div>
                </div>
              </div>

              <div className='col-lg-10 col-12 bg-white prices px-0'>
                <p className="text-center text-muted m-0 py-4"><b>Choose one of the paths below</b></p>

                  <div className='prices d-flex flex-column flex-md-row align-items-stretch justify-content-center pb-4'>
                    {
                      personalizedPrice ? <div className='package personalized px-4'>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className='option'><span>Personalized Career Path</span></div>
                          <div className='price text-right'><b>${Math.round(personalizedPrice.attributes.amount * this.props.rate)}</b> USD</div>
                        </div>

                        <div className="pb-2">
                          <ul className="list-unstyled pl-0 mb-0 d-flex justify-content-between">
                            <div className="d-flex flex-column flex-md-row">
                              <b><span style={{background: '#212121', padding: '4px 8px', color: '#FFF', textTransform: 'uppercase', fontSize: '0.8em'}} className="rounded">Premium</span></b>
                            { ['fsdsai', 'fswd'].includes(selection.attributes.long_symbol) ? <b className="pl-md-1 pt-1 pt-md-0"><span style={{background: '#1647fb', padding: '4px 8px', color: '#FFF', textTransform: 'uppercase', fontSize: '0.8em'}} className="rounded">Most Popular</span></b> : null }
                            </div>

                            <div className="text-right"><i>or ${Math.round(personalizedPrice.attributes.amount_installment * this.props.rate * 100) / 100}/month x 12</i></div>
                          </ul>
                        </div>

                        <div>
                          {(long_symbol === 'fsdsai') && <FsdsaiPersonalized
                            {...propsForProgram}
                          />}
                          {(long_symbol === 'fswd') && <FswdPersonalized
                            {...propsForProgram}
                          />}
                          {(long_symbol === 'fewd') && <FewdPersonalized
                            {...propsForProgram}
                          />}
                          {(long_symbol === 'bewd') && <BewdPersonalized
                            {...propsForProgram}
                          />}

                          <RaisedButton
                            className="normalButton whiteTextButton mt-3"
                            labelStyle={{ fontSize: '1em', fontWeight: 'bold', lineHeight: '40px' }}
                            buttonStyle={{ height: '40px' }}
                            overlayStyle={{ height: '40px' }}
                            backgroundColor="#212121"
                            label="Choose this"
                            fullWidth={true}
                            onClick={() => { this.props.selectProgram('personalized'); }}
                          />
                        </div>
                      </div> : null
                    }
                    <div className='verticalRule d-none d-md-block border-right' />
                    <div className='mt-4 mb-4 mx-4 d-md-none border-bottom' />
                    {
                      immersivePrice ? <div
                        className='package immersive px-4 d-flex flex-column'
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <div className='option'><span>Immersive Path</span></div>
                          <div className='price'><b>${Math.round(immersivePrice.attributes.amount * this.props.rate)}</b> USD</div>
                        </div>

                        <div className="pb-2">
                          <ul className="list-unstyled pl-0 mb-0 d-flex justify-content-between">
                            <div />
                          <div className="text-right"><i>or ${Math.round(immersivePrice.attributes.amount_installment * this.props.rate * 100) / 100}/month x 12</i></div>
                          </ul>
                        </div>

                        {(long_symbol === 'fsdsai') && <FsdsaiImmersive
                          {...propsForProgram}
                        />}
                        {(long_symbol === 'fswd') && <FswdImmersive
                          {...propsForProgram}
                        />}
                        {(long_symbol === 'fewd') && <FewdImmersive
                          {...propsForProgram}
                        />}
                        {(long_symbol === 'bewd') && <BewdImmersive
                          {...propsForProgram}
                        />}

                        <RaisedButton
                          className="normalButton whiteTextButton mt-3"
                          labelStyle={{ fontSize: '1em', fontWeight: 'bold', lineHeight: '40px' }}
                          buttonStyle={{ height: '40px' }}
                          overlayStyle={{ height: '40px' }}
                          backgroundColor="#1976d2"
                          label="Choose this"
                          fullWidth={true}
                          onClick={() => { this.props.selectProgram('immersive'); }}
                        />
                      </div> : null
                    }
                  </div>
              </div>
            </div>
          </div>

          <div className="mx-auto my-3">
            <TopRank />
          </div>
        </div>

        <ReactTooltip place="top" className="solidToolTip p-3 rounded" id="DatesAndTuition" />
      </div>
    );
  }
}

export default StepOne;
